export default [
  {
    path: 'relatorios/gecom-home/dados-revenda',
    name: 'dados-revenda',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Gefin',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Relatórios', link: 'relatorios' },
        { name: 'Gefin' },
      ]
    }
  },
]